import { render, staticRenderFns } from "./ThreadListingItem.vue?vue&type=template&id=53e73a54&scoped=true&"
import script from "./ThreadListingItem.vue?vue&type=script&lang=js&"
export * from "./ThreadListingItem.vue?vue&type=script&lang=js&"
import style0 from "./ThreadListingItem.vue?vue&type=style&index=0&id=53e73a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e73a54",
  null
  
)

export default component.exports